import { ReactElement } from 'react';
import { format } from 'date-fns';
import { getChannel } from 'utils/channelNamesGridded';
import { numberToLetters } from 'utils/letterNumber';

function RunSummary(props: { run: any; calibration: any; isLoading: boolean }): ReactElement {
  const { run, calibration, isLoading } = props;
  const date = run ? new Date(run.run_ts_tz || run.run_ts) : null;

  // Calculate distance
  let distanceText = '';
  if (isLoading) {
    distanceText = 'Loading...';
  } else {
    const distances = getChannel(run?.data_gridded, 'Distance_km', calibration);
    distanceText = distances ? `${distances[distances.length - 1].toFixed(2)}km` : '';
  }

  // Traverse count from TraverseLap_NG00 channel (max value = number of traverses)
  let traverseCount: number | null = null;
  const traverseChannel = run?.data_gridded?.['TraverseLap_NG00'] as number[] | undefined;
  if (traverseChannel && traverseChannel.length > 0) {
    let max = 0;
    for (const v of traverseChannel) {
      if (v > max) max = v;
    }
    if (max > 0) traverseCount = max;
  }

  // Title line: "Config A - Baseline - Run 2"
  const configLetter = calibration?.letter;
  const configDesc = calibration?.description;
  const runNum = run?.run_number;
  const titleParts: string[] = [];
  if (configLetter) titleParts.push(`Config ${configLetter}`);
  if (configDesc) titleParts.push(configDesc);
  if (runNum != null) titleParts.push(`Run ${runNum}`);
  const titleLine = titleParts.join(' - ') || run?.description || 'Run';

  // Distance + traverses line
  const distanceParts: string[] = [];
  if (distanceText) distanceParts.push(`Distance ${distanceText}`);
  if (traverseCount != null) distanceParts.push(`${traverseCount} Traverse${traverseCount !== 1 ? 's' : ''}`);
  const distanceLine = distanceParts.join(' - ');

  return (
    <div>
      <div className="cr-text-lg cr-font-bold cr-text-[#03365D]">{titleLine}</div>
      {date && (
        <div className="cr-text-base cr-text-[#03365D]/70">
          {format(date, 'yyyy-MM-dd')}{'  '}{format(date, 'p')}
        </div>
      )}
      {distanceLine && (
        <div className="cr-text-base cr-text-[#03365D]/70">
          {distanceLine}
        </div>
      )}
      {run?.history && run.history.length > 1 && (
        <div className="cr-mt-3">
          <div className="cr-text-sm cr-font-semibold cr-text-[#03365D]/70">
            Config History
          </div>
          {[...run.history].reverse().map(
            (entry: any, idx: number) => (
              <div
                key={idx}
                className="cr-text-sm cr-text-[#03365D]/50"
              >
                {entry.letter_number === 0
                  ? 'Discard'
                  : `Config ${numberToLetters(entry.letter_number)}`}
                {entry.description ? ` - ${entry.description}` : ''}
                {entry.assignment_ts
                  ? ` (${format(
                      new Date(entry.assignment_ts),
                      'yyyy-MM-dd p',
                    )})`
                  : ''}
              </div>
            ),
          )}
        </div>
      )}
    </div>
  );
}

export default RunSummary;
